import React from 'react';

export default class staticVehicleLists{
//https://stackoverflow.com/questions/5650457/html-select-form-with-option-to-enter-custom-value    
    static vehicleMakeList = (id) => {
        return(
            <datalist id={id}>
                <option>ACME</option>
                <option>Acura</option>
                <option>Aston Martin</option>                
                <option>Audi</option>
                <option>Bentley</option>
                <option>BMW</option>
                <option>Bugatti</option>
                <option>Buick</option>
                <option>Cadillac</option>
                <option>Chevrolet</option>
                <option>Chrysler</option>
                <option>Dodge</option>
                <option>Ford</option>
                <option>Ferrari</option>
                <option>GMC</option>
                <option>Honda</option>
                <option>Hyundai</option>
                <option>Saab</option>
                <option>Jaguar</option>
                <option>Kia</option>
                <option>Lamborghini</option>
                <option>Land Rover</option>
                <option>Lexus</option>
                <option>Lincoln</option>
                <option>Mack</option>
                <option>Maserati</option>
                <option>Mazda</option>
                <option>Mercedes-Benz</option>
                <option>Mitsubishi</option>
                <option>Nissan</option>
                <option>Optima</option>
                <option>Porsche</option>
                <option>Pontiac</option>
                <option>Ram</option>
                <option>Rolls Royce</option>
                <option>Toyota</option>
                <option>Subaru</option>
                <option>Volkswagen</option>
                <option>Volvo</option>
            </datalist>
        )
    }
    
}